import { z } from 'zod';

export const EARLY_CALL_END_REASONS = {
  patient_requested_reschedule_or_cancel:
    'Patient asked to reschedule or cancel',
  patient_joined_then_left: 'Patient joined, then left',
  technical_issue: 'Technical issue (mine or the patient’s)',
  patient_reached_another_way:
    'Patient was reached another way (phone or message)',
  running_late_for_next_appointment: 'Running late for my next appointment',
  other: 'Other',
} as const;

export const END_REASON_OTHER_MAX_LENGTH = 2000;

export const earlyCallEndReasonSchema = z
  .object({
    endReason: z.enum(
      Object.keys(
        EARLY_CALL_END_REASONS,
      ) as (keyof typeof EARLY_CALL_END_REASONS)[],
    ),
    endReasonOther: z
      .string()
      .trim()
      .max(END_REASON_OTHER_MAX_LENGTH)
      .optional(),
  })
  .superRefine((value, ctx) => {
    if (value.endReason === 'other' && !value.endReasonOther) {
      ctx.addIssue({
        code: 'custom',
        path: ['endReasonOther'],
        message: 'Please describe your reason for ending early.',
      });
    }
  })
  .transform(({ endReason, endReasonOther }) => ({
    endReason,
    ...(endReason === 'other' ? { endReasonOther } : {}),
  }));

export type EarlyCallEndReason = z.infer<typeof earlyCallEndReasonSchema>;
